module.exports = __webpack_public_path__ + "static/media/free-root-beer-2024-dt-fr.84ad1a53.jpg";